import { render, staticRenderFns } from "./honoraryAwards.vue?vue&type=template&id=001f1a82&scoped=true"
import script from "./honoraryAwards.vue?vue&type=script&lang=js"
export * from "./honoraryAwards.vue?vue&type=script&lang=js"
import style0 from "./honoraryAwards.vue?vue&type=style&index=0&id=001f1a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001f1a82",
  null
  
)

export default component.exports